import { lazy } from "react";
import { useContainer } from "./model/useContainer.js";
const widget = {
  useContainer,
  component: lazy(() => import("./ui/index.js").then((module) => ({ default: module.ComparisonFooter })))
};
export {
  useContainer,
  widget
};
